import React, { useState } from 'react';
import { notification } from 'antd';
import { DateRangePicker } from 'react-date-range';
import { useGlobalState } from './GlobalState';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useHistory } from 'react-router';
import moment from 'moment-timezone';
import axios from 'axios';

import { useGetDashboardDataMutationMutation } from '../../calendar/eventAdminCalendarSlice';

export default function SelectKPIFilterDate() {
  const history = useHistory();
  const [bookingDates, setBookingDates] = useGlobalState('bookingDates');
  const [, setKpis] = useGlobalState('kpis');

  const [, setLoading] = useState('loading');
  const [getDashboardData] = useGetDashboardDataMutationMutation();

  const handleDateChange = (item) => {
    let payload_data = {
      start: moment(item.selection.startDate).format('YYYY-MM-DD'),
      end: moment(item.selection.endDate).format('YYYY-MM-DD'),
    };
    setBookingDates([item.selection]);
    setLoading(true);
    getDashboardData(payload_data)
      .unwrap()
      .then((res) => {
        setKpis(res);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <DateRangePicker
      onChange={(item) => handleDateChange(item)}
      months={2}
      ranges={bookingDates}
      direction='horizontal'
      color='black'
      rangeColors={['black', 'white']}
    />
  );
}
